import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CompanyFindInterface } from '@zaoblako/shared/modules/client/dtos/company/find/company-find.dto';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { CompanySingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/company-single-select/company-single-select.component';

@Component({
  selector: 'crm-company-deleting-modal',
  standalone: true,
  imports: [CommonModule, ButtonComponent, CompanySingleSelectComponent],
  templateUrl: './company-deleting-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyDeletingModalComponent {
  public company: CompanyFindInterface;

  public previousCompanyIds: number[] = [];

  public constructor(private readonly config: DynamicDialogConfig, public readonly ref: DynamicDialogRef) {
    if (config.data?.previousCompanyIds) {
      this.previousCompanyIds = [config.data?.previousCompanyIds];
    }
  }
}
